import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

export interface User {
  username: string;
  first_name: string;
  last_name: string;
  blog_profile_url: string;
  email: string;
  user_id: string;

}

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {

  isLoggedIn : boolean = false;
  blog_data

  constructor(private _authService : AuthService) { }

  ngOnInit(): void {
    this._authService.loggedIn().subscribe(data=>{
      if(data != 'invalid'){
        this.blog_data = data;
        this.isLoggedIn = true;
      }else{
        this.isLoggedIn = false;
      }
    });
  }

}
